import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { saveAs } from 'file-saver';
import { HttpAlertService } from 'src/app/services/http-alert.service';

@Component({
    selector: 'data-export',
    templateUrl: './data-export.component.html',
    styleUrls: ['./data-export.component.scss']
})
export class DataExportComponent {

    dateFrom: Date;
    dateTo: Date;
    showLoaderUsers: boolean = false;
    showLoaderInvoices: boolean = false;

    constructor(private adminService: AdminService, private alertService: HttpAlertService) { }

    public downloadUsersExcel(): void {
        this.showLoaderUsers = true;
        this.adminService.downloadUsersExcel().subscribe(
            blob => {
                this.showLoaderUsers = false;
                let name = this.prepareDateName();
                let outputname = name + '_users_.xlsx';
                saveAs(blob, outputname);
            }
        );
    }

    public downloadInvoices(): void {
        if (this.dateFrom == undefined || this.dateTo == undefined) {
            this.alertService.error('date_error_1');
        } else if (this.dateFrom > this.dateTo) {
            this.alertService.error('date_error_2');
        } else {
            this.showLoaderInvoices = true;
            let stringDateFrom = this.buildStringDate(this.dateFrom);
            let stringDateTo = this.buildStringDate(this.dateTo);
            this.adminService.downloadInvoices(stringDateFrom, stringDateTo).subscribe(
                blob => {
                    this.showLoaderInvoices = false;
                    if (blob.size < 100) {
                        this.alertService.error('date_error_3');
                    } else {
                        let name = this.prepareDateName();
                        let outputname = name + '_invoices_.zip';
                        saveAs(blob, outputname);
                    }
                }
            );
        }
    }

    private buildStringDate(inputDate: Date): string {
        const d = new Date(inputDate);
        const month = (d.getMonth() + 1) < 10 ? '0' + '' + (d.getMonth() + 1) : (d.getMonth() + 1);
        const date = d.getDate() < 10 ? '0' + '' + d.getDate() : d.getDate()
        return d.getFullYear() + '-' + month + '-' + date;

    }

    private prepareDateName(): string {
        const d = new Date();
        const year = d.getFullYear();
        const month = (d.getMonth() + 1) < 10 ? '0' + '' + (d.getMonth() + 1) : (d.getMonth() + 1);
        const date = d.getDate() < 10 ? '0' + '' + d.getDate() : d.getDate()
        const hour = d.getHours() < 10 ? '0' + '' + d.getHours() : d.getHours();
        const minute = d.getMinutes() < 10 ? '0' + '' + d.getMinutes() : d.getMinutes();
        const secound = d.getSeconds() < 10 ? '0' + '' + d.getSeconds() : d.getSeconds();
        return year + '_' + month + '_' + date + '_' + hour + '_' + minute + '_' + secound;
    }


}